import React from "react";

// Mesmas cores da barra de progresso de materiais (components/MaterialProgress).
const FULL = "#1AB394";
const HALF = "#1D84C6";
const LOW = "#FFAA00";
const CRITICAL = "#FB404B";
const NEUTRAL = "#AEB7C2";

const VIEWBOX_WIDTH = 80;
const VIEWBOX_HEIGHT = 200;
const TOP = 12;
const BOTTOM = 192;

// Cúpula rasa em cima e a mesma curva espelhada embaixo.
const OUTLINE = "M 12 26 A 28 14 0 0 1 68 26 L 68 178 A 28 14 0 0 1 12 178 Z";
// Costuras levemente arqueadas para baixo, acompanhando o cilindro.
const SEAM_CURVE = "q 40 6 80 0";
const SEAMS = [64, 108, 148];

export const siloFillColor = (percentage) => {
  if (percentage >= 90) return FULL;
  if (percentage >= 50) return HALF;
  if (percentage >= 10) return LOW;
  return CRITICAL;
};

const Silo = ({
  id,
  percentage,
  missingCapacity = false,
  monitored = true,
}) => {
  const hasLevel = monitored && !missingCapacity && percentage !== null;
  const bounded = hasLevel ? Math.max(0, Math.min(100, percentage)) : 0;
  const height = (bounded / 100) * (BOTTOM - TOP);
  const levelY = BOTTOM - height;
  const color = hasLevel ? siloFillColor(bounded) : NEUTRAL;

  const clipId = `silo-clip-${id}`;
  const hatchId = `silo-hatch-${id}`;

  return (
    <svg
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      style={{
        display: "block",
        width: "100%",
        height: "auto",
        opacity: monitored ? 1 : 0.42,
      }}
    >
      <defs>
        <clipPath id={clipId}>
          <path d={OUTLINE} />
        </clipPath>

        {missingCapacity && (
          <pattern
            id={hatchId}
            width="8"
            height="8"
            patternTransform="rotate(45)"
            patternUnits="userSpaceOnUse"
          >
            <line x1="0" y1="0" x2="0" y2="8" stroke={NEUTRAL} strokeOpacity="0.5" strokeWidth="3" />
          </pattern>
        )}
      </defs>

      <g clipPath={`url(#${clipId})`}>
        <rect x="0" y="0" width={VIEWBOX_WIDTH} height={VIEWBOX_HEIGHT} fill="#fff" fillOpacity="0.07" />

        {missingCapacity && (
          <rect x="0" y="0" width={VIEWBOX_WIDTH} height={VIEWBOX_HEIGHT} fill={`url(#${hatchId})`} />
        )}

        {height > 0 && (
          <rect x="0" y={levelY} width={VIEWBOX_WIDTH} height={height} fill={color} fillOpacity="0.34" />
        )}

        <g fill="none" stroke={color} strokeOpacity="0.55" strokeWidth="2.4">
          {SEAMS.map(seam => <path key={seam} d={`M 0 ${seam} ${SEAM_CURVE}`} />)}
        </g>

        {height > 0 && (
          <path d={`M 0 ${levelY} ${SEAM_CURVE}`} fill="none" stroke={color} strokeWidth="3.4" />
        )}
      </g>

      <path d={OUTLINE} fill="none" stroke={color} strokeWidth="3.4" strokeLinejoin="round" />
    </svg>
  );
};

export default Silo;
